type SignaturePlaceholderKey =
  | "firstName"
  | "lastName"
  | "address"
  | "date"
  | "signature";

export function resolveInputPlaceholder(
  block: any,
  fallback: string,
): string {
  const value = block?.config?.placeholder;
  if (typeof value === "string" && value.trim()) {
    return value.trim();
  }
  return fallback;
}

export function resolveSignaturePlaceholder(
  block: any,
  key: SignaturePlaceholderKey,
  fallback: string,
): string {
  const value = block?.config?.placeholders?.[key];
  if (typeof value === "string" && value.trim()) {
    return value.trim();
  }
  return fallback;
}
